<template>
  <label
    :class="{
      'pointer-events-none':
        !itemopcao.pode_responder || !itemopcao.pode_ver,
    }"
    class="px-16 py-8 grid justify-center h-full items-center border-b border-b-neutral-100/10 group cursor-pointer"
  >
    <q-checkbox
      :class="{
        'opacity-60': !itemopcao.pode_responder,
        invisible: !itemopcao.pode_ver,
      }"
      :style="{ '--q-primary': colorActive }"
      :model-value="!!colorActive"
      size="24px"
      class="text-headline-3 w-full mx-auto text-[var(--cor)]"
      @click="$emit('click:opt')"
    />
  </label>
</template>

<script setup>
const props = defineProps({
  label: String,
  itemopcao: Object,
  colorActive: String,
})
const emit = defineEmits(['click:opt'])
</script>

<style lang="scss" scoped></style>
